module.exports = __webpack_public_path__ + "img/greyList2.aa94adcd.png";